import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { history } from 'kts-platform-frame/routes';
import { outputApi } from 'src/api';
import { message } from 'antd';
import { JSObject } from 'kts-scaffold-framework/utils/kit';
const FIRSTPAGE: number = 1;
class ModulesAction extends ActionBasic<ModulesState> {

    public getData = (page?: number) => {
        const { fields, pageSize } = this.modulesState;
        let data = {
            pageNum: page || this.modulesState.pageNum,
            pageSize,
            ...fields
        };
        data = {
            ...data,
            'minCreateTime': fields['minCreateTime'] && fields['minCreateTime'].format('YYYY-MM-DD'),
            'maxCreateTime': fields['maxCreateTime'] && fields['maxCreateTime'].format('YYYY-MM-DD'),
        };
        data=JSObject.getClearBlankParas(data);

        outputApi.outputList(this, data).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    this.modulesState.list = res;
                    this.modulesState.selectedRows = [];
                    this.modulesState.selectedRowKeys = [];
                    this.setModulesState();
                }
            }
        });
    }
    public handleFormChange = (changedFields) => {
        this.modulesState.fields = { ...this.modulesState.fields, ...changedFields };
        //history.push({pathname:});
        this.setModulesState().then(() => {
            this.getData(FIRSTPAGE);
        });
    }
}

export default new ModulesAction();



// WEBPACK FOOTER //
// ./src/display/apps/OutputSettlement/Modules.Action.ts